import { Card } from '@blueprintjs/core'
import React from 'react'
/** @jsx jsx */
import { css, jsx } from '@emotion/core'

function InPopover ({ children, className }) {
  return (
    <Card className={className} css={css`max-height: 500px; overflow: auto; box-shadow: none;`}>{children}</Card>
  )
}

export default InPopover
